import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";

const TeacherEnglishBoundary = ({ children }) => {
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    // Teacher pages are intentionally English-only. Set direction immediately
    // before paint so entering from an Arabic page cannot render the dashboard RTL.
    document.documentElement.dir = "ltr";
    document.documentElement.lang = "en";
    document.body.dir = "ltr";
    document.body.style.direction = "ltr";

    if (!i18n.language?.startsWith("en")) {
      i18n.changeLanguage("en");
    }

    // Do not restore the previous language during cleanup: each teacher route
    // owns this boundary, and restoring Arabic while navigating between them
    // was the source of the RTL dashboard bug.
  }, [i18n]);

  return (
    <div dir="ltr" lang="en" style={{ direction: "ltr", textAlign: "left", minHeight: "100%" }}>
      {children}
    </div>
  );
};

export default TeacherEnglishBoundary;
